import * as Highcharts from 'highcharts';
import { useEffect } from 'react';

interface donutInterfac {
  data: Array<{
    name: string;
    y: number;
    drilldown: string;
  }>;
}

const DonutChart = ({ data }: donutInterfac): JSX.Element => {
  const renderChart = () => {
    new Highcharts.Chart({
      chart: {
        renderTo: 'donutContainer',
        type: 'pie',
        backgroundColor: 'transparent',
        spacingTop: -10,
      },
      title: {
        text: '',
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        symbolHeight: 16,
        symbolWidth: 16,
        squareSymbol: true,
        symbolRadius: 2,
        symbolPadding: 16,
        itemStyle: {
          fontSize: '14px',
          fontWeight: '500',
          fontFamily: 'Gilroy,sans-serif,Arial',
        },
      },
      plotOptions: {
        pie: {
          colors: ['#4ADF93', '#D0E4FE', '#1678FB'],
          startAngle: -90,
          endAngle: 90,
          center: ['50%', '100%'],
          size: '190%',
          fillColor: '#F5F5F5',
          // allowPointSelect: true,
          // cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },

        series: {
          animation: false,
          dataLabels: {
            enabled: false,
          },
          states: {
            hover: {
              enabled: true,
              borderWidth: 2,
              borderColor: '#349C67',
            },
          },
        },
      },
      tooltip: {
        headerFormat: '',
        pointFormat: '<b>{point.name}</b>: {point.y:.1f}',
      },
      credits: {
        enabled: false,
      },

      series: [
        {
          innerSize: '45%',
          type: 'pie',
          data: [...data],
        },
      ],
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              series: [
                {
                  innerSize: '45%',
                  type: 'pie',
                  data: [...data],
                },
              ],
              plotOptions: {
                pie: {
                  center: ['50%', '90%'],
                  size: '175%',
                },
              },
            },
          },
        ],
      },
    });
  };

  useEffect(() => {
    renderChart();
  }, [data]);

  return (
    <div>
      <div
        id="donutContainer"
        className="mx-auto"
        style={{ height: '200px', width: '90%', background: 'transparent' }}
      ></div>
    </div>
  );
};

export default DonutChart;
